import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Shell } from '~/components/layout/Shell';
import { AccountsPage } from '~/pages/Accounts';
import { CardholdersPage } from '~/pages/Cardholders';
import { HomePage } from '~/pages/Home';
import { KeysPage } from '~/pages/Keys';
import { KybPage } from '~/pages/Kyb';
import { LoginPage } from '~/pages/Login';
import { ProgramsPage } from '~/pages/Programs';
import { SignupPage } from '~/pages/Signup';
import { VerifyEmailPage } from '~/pages/VerifyEmail';

export function App(): JSX.Element {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route element={<Shell />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/programs" element={<ProgramsPage />} />
          <Route path="/accounts" element={<AccountsPage />} />
          <Route path="/cardholders" element={<CardholdersPage />} />
          <Route path="/keys" element={<KeysPage />} />
          <Route path="/kyb" element={<KybPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
